const Utils = {

  orderArrayObjectByFieldNumberAsc: function (field) {
    return function (a, b) {
      return a[field] - b[field]
    }
  },

  orderArrayObjectByFieldNumberDesc: function (field) {
    return function (a, b) {
      return b[field] - a[field]
    }
  },

  orderArrayObjectByFieldAlphabeticalAsc: function (field) {
    return function (a, b) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
      return 0
    }
  },

  orderArrayObjectByFieldAlphabeticalDesc: function (field) {
    return function (a, b) {
      if (a[field] < b[field]) return 1
      if (a[field] > b[field]) return -1
      return 0
    }
  },

  orderArrayObjectByFieldAlphabeticalAscInvariant: function (field) {
    return function (a, b) {
      if (a[field].toLowerCase() < b[field].toLowerCase()) return -1
      if (a[field].toLowerCase() > b[field].toLowerCase()) return 1
      return 0
    }
  },

  orderArrayObjectByFieldAlphabeticalDescInvariant: function (field) {
    return function (a, b) {
      if (a[field].toLowerCase() < b[field].toLowerCase()) return 1
      if (a[field].toLowerCase() > b[field].toLowerCase()) return -1
      return 0
    }
  },

  remapArrayObject: function (fields) {
    return function (obj) {
      var res = {}
      for (var index in fields) {
        var prop = fields[index]
        if (!obj.hasOwnProperty(prop)) continue

        res[prop] = obj[prop]
      }
      return res
    }
  },

  remapObject: function (obj, fields) {
    var res = {}
    for (var index in fields) {
      var prop = fields[index]
      if (obj.hasOwnProperty(prop)) {
        res[prop] = obj[prop]
      }
    }
    return res
  },

  generateGUID: function () {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1).padStart(4)
    }

    return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase()
  },

  removeObjectFromArrayObject: function (arrayObject, propertyNameToDelete, propertyValueToDelete) {
    arrayObject.splice(arrayObject.map(function (item) {
      return item[propertyNameToDelete]
    }).indexOf(propertyValueToDelete), 1)
    return arrayObject
  },

  modulesToModuleLayers: function (modules) {
    var moduleLayers = []
    var modulesMapping = {
      'CORE': ['ThirdPartyMembers', 'ThirdPartyStaffs', 'ThirdPartyDevice', 'ThirdPartyGroups'],
      'BIOMETRICS': ['ThirdPartyBiometrics'],
      'CLASSES': ['ThirdPartyClassSchedule'],
      'ASPIRATIONS': ['ThirdPartyAspirations'],
      'RESULTS': ['ThirdPartyTrainingResults'],
      'TRAINING PROGRAMS': ['ThirdPartyBrowseExercise', 'ThirdPartyTPRead', 'ThirdPartyEquipmentList']
    }

    for (var layerName in modulesMapping) {
      var layer = []
      for (var i = 0; i < modulesMapping[layerName].length; i++) {
        layer.push(modules.find((mod) => { return mod.name === modulesMapping[layerName][i] }))
      }
      moduleLayers.push({name: layerName, modules: layer})
    }
    return moduleLayers
  },

  modulesLayerToModuleIds: function (tempModules) {
    var selectedModules = []
    for (var i = 0; i < tempModules.length; i++) {
      for (var j = 0; j < tempModules[i].modules.length; j++) {
        selectedModules.push(tempModules[i].modules[j].id)
      }
    }
    return selectedModules
  },

  modulesLayerFromAvailableModules: function (tempModules) {
    var selectedModules = []
    for (var i = 0; i < tempModules.length; i++) {
      var areAvailables = true
      for (var j = 0; j < tempModules[i].modules.length; j++) {
        if (!tempModules[i].modules[j].isAvailable) {
          areAvailables = false
          break
        }
      }
      if (areAvailables) {
        selectedModules.push(tempModules[i])
      }
    }
    return selectedModules
  }
}

export default Utils
